import { FONT } from "@/styles/common";
import { Box, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface CustomBoxProps {
    annotation?: string;
}

export const CustomBox = styled(Box)<CustomBoxProps>`
    position: relative;

    & .catch_praise_annotation {
        ${FONT("cormorant", 20, 700, 1.2)}
    }

    & .main_kr {
        ${FONT("notoSerif", 52, 500, 1.2)}

        @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
            ${FONT("notoSerif", 32, 500, 1.2)}
        }

        @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
            ${FONT("notoSerif", 24, 500, 1.2)}
        }
    }

    & .main_en {
        ${FONT("cormorant", 52, 500, 1.2)}

        @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
            ${FONT("cormorant", 32, 500, 1.2)}
        }

        @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
            ${FONT("cormorant", 24, 500, 1.2)}
        }
    }

    &::before {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        background: ${({ theme }) => theme.COLOR.text[500]};
    }
`;

export const CustomSubBox = styled(Flex)`
    & .sub_kr {
        ${FONT("notoSerif", 16, 500, 1.2)}

        @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
            ${FONT("notoSerif", 14, 500, 1.2)}
        }
    }

    & .sub_en {
        ${FONT("cormorant", 16, 500, 1.2)}

        @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
            ${FONT("notoSerif", 14, 500, 1.2)}
        }
    }
`;

interface CustomSubTextProps {
    isDetail: boolean;
    pathName: string;
}

export const CustomSubText = styled(Text)<CustomSubTextProps>`
    & > div > p {
        width: ${({ isDetail, pathName }) => (isDetail || pathName.includes("/rooms") ? "auto" : "360px")};
        overflow: ${({ isDetail }) => (isDetail ? "" : "hidden")};
        text-overflow: ${({ isDetail }) => (isDetail ? "" : "ellipsis")};
        white-space: ${({ isDetail, pathName }) => (isDetail || pathName.includes("/rooms") ? "wrap" : "nowrap")};
    }
`;
